export const getGeoLocation = (state) => state.session.geoLocation;
